module.exports = __webpack_public_path__ + "static/1.2.C.2 Randare 2-fbc91fe3938311ee84e14708c34a97da.jpg";